import { createContext, useContext, useState, useEffect } from 'react';
import es from '../locales/es.json';
import en from '../locales/en.json';
import pt from '../locales/pt.json';

const LanguageContext = createContext();
const translations = { es, en, pt };

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return (saved && translations[saved]) ? saved : 'es';
  });
  const [t, setT] = useState(() => translations[language] || es);

  useEffect(() => {
    setT(translations[language] || es);
  }, [language]);

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const translate = (key, vars = {}) => {
    const keys = key.split('.');
    let val = t;
    for (const k of keys) {
      val = val?.[k];
    }
    if (typeof val !== 'string') return key;
    return Object.entries(vars).reduce(
      (s, [k, v]) => s.replace(new RegExp(`{{${k}}}`, 'g'), String(v)),
      val
    );
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t: translate }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
